import React from "react";
import ExamPageLayout from "./ExamPageLayout";

const DelfDalf = () => (
    <ExamPageLayout
        title="DELF & DALF"
        subtitle="Diplômes d'études en langue française"
        description="DELF (Diplôme d'Études en Langue Française) and DALF (Diplôme Approfondi de Langue Française) are official diplomas from the French Ministry of Education. They certify French proficiency from A1 to C2. DELF B2 is widely required for study in French universities. LinguaScore supports your preparation with targeted practice."
        structure="Four skills at each level: listening, reading, writing, speaking. Levels A1–B2 (DELF), C1–C2 (DALF). Diplomas are permanent."
    />
);

export default DelfDalf;
